module.exports = __webpack_public_path__ + "img/kopsurat_moyudan_sm.d3ba52d2.png";